import { useMemo, useState } from 'react';
import { Search } from 'lucide-react';
import {
  Input,
  Button,
  Badge,
  Dialog,
  DialogTrigger,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogBody,
  DialogFooter,
  DialogClose,
} from '@vnetwork/ui/primitives';
import { DialogContent } from '@vnetwork/margarita-shell/DialogContent';
import { BLOCKED_DOMAINS } from './blocked-email-domains';

/**
 * Inline "here" link that opens a searchable list of the blocked free/temporary
 * email domains. Used in the business register email-field helper so the user can
 * see exactly which providers are rejected.
 */
export function BlockedEmailsLink() {
  const [query, setQuery] = useState('');
  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    return q ? BLOCKED_DOMAINS.filter((d) => d.includes(q)) : BLOCKED_DOMAINS;
  }, [query]);

  return (
    <Dialog onOpenChange={(o) => !o && setQuery('')}>
      <DialogTrigger asChild>
        <button
          type="button"
          style={{
            border: 'none', background: 'none', padding: 0, font: 'inherit',
            color: 'var(--vn-primary-text)', textDecoration: 'underline', cursor: 'pointer',
          }}
        >
          here
        </button>
      </DialogTrigger>
      <DialogContent size="sm">
        <DialogHeader>
          <DialogTitle>Blocked Email Domains</DialogTitle>
          <DialogDescription>
            Free and temporary email providers are not allowed
          </DialogDescription>
        </DialogHeader>
        <DialogBody>
          <p style={{ margin: `0 0 var(--vn-space-3)`, fontSize: 'var(--vn-font-size-md)' }}>
            The following email domains are not eligible for business accounts.
            Please use your company email address to register.
          </p>
          <Input
            inputSize="sm"
            placeholder="Search domains…"
            startSlot={<Search />}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <div
            style={{
              display: 'flex', flexWrap: 'wrap', gap: 'var(--vn-space-2)', marginTop: 'var(--vn-space-3)',
              maxHeight: 200, overflowY: 'auto',
            }}
          >
            {filtered.length === 0 ? (
              <span style={{ fontSize: 'var(--vn-font-size-md)', color: 'var(--vn-fg-muted)' }}>
                No matching domains.
              </span>
            ) : (
              filtered.map((d) => (
                <Badge key={d} tone="neutral">{d}</Badge>
              ))
            )}
          </div>
        </DialogBody>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="secondary">Close</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
